'use client';
import { jsx, jsxs } from 'react/jsx-runtime';
import { getSwanImageUrl } from '../../../core/utilities/manifest-images.utils.js';
import { AlertBoxContext } from './alert-box.context.js';
import { useInternalOptionalSwanI18nContext } from '../../contexts/i18n/swan-i18n-provider.context.js';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { getDeprecatedI18nPropMessage } from '../../hooks/use-required-i18n-props.js';
import { useSwanContext } from '../../contexts/swan-provider/swan-provider.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { useControllableValue } from '../../hooks/use-controllable-value.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(o = 0; o < s.length; o++)r = s[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, s = Object.keys(e);
    for(o = 0; o < s.length; o++)r = s[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const AlertBox = renderWithRef('AlertBox', null, (s, b)=>{
    let { swanPathType: f, swanBaseUrl: m } = useSwanContext(), w = useInternalOptionalSwanI18nContext(), O = getSwanImageUrl('legalWarning', f, m);
    useComponentStylesLoaded('AlertBox', SWAN_STYLE_KEY_MAP.alertBox), useDeprecatedProps('AlertBox', s, [
        {
            propName: 'skin',
            deprecatedValues: {
                standard: 'Use skin="info" instead.',
                positive: 'Use skin="success" instead.'
            }
        },
        {
            propName: 'width',
            instructions: 'To maintain consistent user experience `width` is deprecated without a replacement.'
        },
        {
            propName: 'accessibleTextForIcon',
            instructions: getDeprecatedI18nPropMessage(w)
        }
    ]);
    let { skin: _ = 'info', width: j = 'standard', toast: y = false, children: x, accessibleTextForIcon: g, dismissed: h, onRequestDismiss: v } = s, P = _object_without_properties(s, [
        "skin",
        "width",
        "toast",
        "children",
        "accessibleTextForIcon",
        "dismissed",
        "onRequestDismiss"
    ]), [k, D] = useControllableValue({
        value: h,
        onChange: v || void 0,
        defaultValue: false,
        defaultOnChange: (e)=>{
            e(true);
        }
    });
    if (k) return null;
    let S = new Set([
        'swan-vanilla-ignore',
        'swan-alert-box'
    ]);
    _ && 'info' !== _ && 'standard' !== _ && S.add(`swan-alert-box-skin-${_}`), 'narrow' === j && S.add("swan-alert-box-narrow"), y && S.add("swan-alert-box-toast");
    let B = g;
    w && !g && (B = w.t(`alert-box.accessible-text-for-skin-${'standard' === _ ? 'info' : 'positive' === _ ? 'success' : _}-icon`));
    let N = {};
    return B && (N = {
        role: 'img',
        'aria-label': B
    }), jsx(AlertBoxContext.Provider, {
        value: {
            onRequestDismiss: D
        },
        children: jsxs(RenderComp, {
            root: "div",
            forwardedRef: b,
            classNames: S,
            props: _object_spread_props(_object_spread({}, P), {
                role: 'alert'
            }),
            children: [
                'legal-warning' === _ && O ? jsx("img", {
                    src: O,
                    alt: B || ''
                }) : jsx("span", _object_spread_props(_object_spread({}, N), {
                    className: `swan-alert-box-icon swan-alert-box-icon-${_}`
                })),
                x
            ]
        })
    });
});

export { AlertBox };
